import { WidgetType } from './WidgetType';

export interface SettingsRouter {
  goToMainSettings(companyId?: string, eventTypeId?: string): void;

  goToCompanyStructure(id: string): void;

  goToCompanyProfilesEdit(id: string): void;

  goBack(prevState: { pathname: string; search: string }): void;

  goToCompanySettings(): void;

  goToCompanyAccessProfiles(id: string): void;

  goToCompanyAccessProfilesSetup(id: string): void;

  goToEditCompanyTimezone(id: string): void;

  goToCreateCompanyTimezoneException(id: string): void;

  goToCompanyTimezone(id: string): void;

  goToCompanyDashboardSettings(id: string): void;

  goToCompanyDashboard(id: string): void;

  goToCompanyWidget(id: string, widgetId: string, widgetType: WidgetType): void;

  goToEventTypes(id: string, collectionId: string): void;

  goToCompanyLogoSettings(id: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsRouter = Symbol('SettingsRouter');
